import '../Tutorial.css';
import React from 'react';
import TutorialGirl from "../TutorialGirl";
import Typewriter from "typewriter-effect";

function T120ClickBuy() {

    /*
  useEffect(() => {
    UserService.sendEvent('ClickBuy120');
  }, []);
     */
const  text = 'Let\'s go to the \'Deck\' and add new cards to your deck so you can play with them.';

    return (
        <div>
            <div className={'T120Top'}></div>


            <TutorialGirl position={'Right'} undressingProcess={3}/>
            <div className='tutorialContainer tutorialTopContainer120'>
                <div className='tutorialBottomTextField'><Typewriter
                    options={{
                        delay: 30
                    }}
                    onInit={(typewriter) => {
                        typewriter.typeString(text).start();
                    }}
                /></div>
            </div>

        </div>

    );
}

export default T120ClickBuy;
